<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{ $t('string.msg.menu.banner.label.title') }}</h4>
                            </div>
                        </div>
                    </div>

                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{ $t('string.msg.banner.label.decription') + ' ' +
                                        $t('string.msg.banner.label.decription2') }}
                                </p>
                                <form>
                                    <div v-if="data._id" class="form-row">
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{ $t('string.msg.product.brand.label.id') }}
                                            </label>
                                            <input type="text" readonly v-model="data._id" class="form-control" />
                                        </div>

                                        <div class="form-group col-md-2">
                                            <br /><br />
                                            <button v-on:click="confirmArchive"
                                                class="text-dark-gray btn btn-warning w-100">{{
                                                    $t('string.msg.status.archive') }}</button>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{ $t('string.msg.banner.label.company') }}
                                            </label>
                                            <input type="text" v-model="data.company" class="form-control" />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{ $t('string.msg.banner.label.site.url') }}
                                            </label>
                                            <input type="text" v-model="data.siteURL" class="form-control" />
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{ $t('string.msg.banner.label.time') }}
                                            </label>
                                            <input type="text" v-model="data.time" class="form-control" v-mask="['##']" />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{ $t('string.msg.banner.label.priority') }}
                                            </label>
                                            <input type="text" v-model="data.priority" class="form-control"
                                                v-mask="['##']" />
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{ $t('string.msg.banner.label.date') }}
                                            </label>
                                            <input v-if="data.date" type="text"
                                                :value="new Date(data.date).toLocaleDateString()" readonly
                                                class="form-control" />
                                            <input v-else type="text" :value="null" readonly class="form-control" />
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{ $t('string.msg.banner.label.status') }}
                                            </label>
                                            <input type="text" :value="$t(data.status)" readonly class="form-control" />
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label"> <code class="highlighter-rouge">*</code> {{
                                                $t('string.msg.banner.label.banner-attachment') }} </label>
                                            <input type="file" id="banner" ref="file" v-on:change="handleFileUpload()"
                                                class="form-control" />
                                        </div>
                                        <div v-if="data.bannerURL" class="form-group col-md-8" style="text-align: center">
                                            <!-- <img v-if="data.bannerURL" v-bind:src="`${domain}${data.bannerURL}`" alt="image" height="200" width="800" /> -->
                                            <img v-if="data.bannerURL" v-bind:src="data.bannerURL" alt="image"
                                                height="100" />
                                        </div>
                                    </div>
                                </form>
                                <br />
                                <div v-if="errors.length" class="alert alert-danger">
                                    <p class="lead">{{ $t('response.msg.error.empty.fields') }}</p>
                                    <ul>
                                        <li v-bind:key="error" v-for="    error     in     errors    ">{{ error }}</li>
                                    </ul>
                                </div>

                                <br />
                                <div class="form-row">
                                    <div class="form-group col-md-6 text-center">
                                        <button @click="clearForm" class="btn btn-secondary w-50">{{
                                            $t('string.msg.form.btn.clear') }}</button>
                                    </div>
                                    <div class="form-group col-md-6 text-center">
                                        <button @click="checkForm" class="btn btn-danger w-50">{{
                                            $t('string.msg.form.btn.save') }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <List v-on:load-item="selectItem" />
                </div>
            </div>
        </div>
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText"
            v-on:confirmation-return="archive" />
    </div>
</template>

<script>
import List from './ListBanner'
import Controller from './CrtBanner'
import Spinner from '../../components/layout/Spinner'
import Toast from '../../components/layout/Toast'
import Confirmation from '../../components/layout/Confirmation'
import Endpoints from '../../components/common/Endpoints'

let maxDate = new Date()
maxDate.setMonth(maxDate.getMonth() + 3)

export default {
    name: 'Banner',
    components: {
        Spinner,
        Toast,
        List,
        Confirmation,
    },
    data() {
        return {
            errors: [],
            disabledDates: {
                to: new Date(), // Disable all dates up to specific date,
                from: maxDate, // Disable all dates after specific date
            },
            valuekey: 0,
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            companies: [],
            domain: Endpoints.domain,
            file: null,
            data: {
                siteURL: null,
                bannerURL: null,
                company: null,
                time: null,
                priority: null,
                date: null,
                status: null,
            },
        }
    },
    methods: Controller.methods,
    created() {
        Controller.init(this)
    },
    mounted() { },
}
</script>

<style></style>
